// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDefaultState as getIsValidDefaultState} from '../state';
import {getValidPinDetails} from '../../shared/repositories';
import {updatePIN} from './duplicate-pin-plate';

export const resetProductDetails = () =>

    dispatch =>

        dispatch({
            data: getIsValidDefaultState().isValid,
            type: actions.UPDATE_PRODUCT_DUPLICATE_PIN_PLATE
        });

/* eslint-disable complexity, max-params */

export const readProductDetails = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getValidPinDetails(pin);

            dispatch({
                data,
                type: actions.UPDATE_PRODUCT_DUPLICATE_PIN_PLATE
            });

            updatePIN(pin)(dispatch);

        } catch (error) {

            resetProductDetails()(dispatch);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/validate-pin.js